import React from 'react'
import { Carousel } from 'primereact/carousel'
import { UserQuestionResponse } from '../../../../../../../common/types/user'
import { EnumUserQuestionsData } from 'types/enums.options'
import { getUserQuestionsEnum } from '_services/enums.service'
import { useFetchV2 } from '../../../../../_core/hooks'
import Skeleton from '../../../../../components/skeleton'

type QuestionCarouselProps = {
  responses:UserQuestionResponse[]
}

const QuestionResponse = React.memo(({ response,questions }:{ response:UserQuestionResponse,questions:EnumUserQuestionsData[] }) =>
  <div className="card border question-content my-2">
    <h4 className="text-center">{response.toQuestion.question}</h4>
    <div className="my-3">
      <p className="text-center">
        {response.toQuestion.response}
        {questions.find((x) => x.id == response.questionId)?.options.find((x) => x.id === response.questionOptionId)?.display ?? ''}
      </p>
    </div>
  </div>
)

const QuestionsCarousel = (props:QuestionCarouselProps) => {
  const [questions] = useFetchV2<EnumUserQuestionsData[],undefined>(getUserQuestionsEnum,undefined,[])
  return (
    <Skeleton dependency={questions}>{(questions) =>
    <Carousel
      value={props.responses}
      numVisible={1}
      numScroll={1}
      orientation="horizontal"
      verticalViewPortHeight="160px"
      itemTemplate={(response:UserQuestionResponse) => <QuestionResponse response={response} questions={questions}/>}
      showIndicators={false}
    />
    }</Skeleton>
  )
}

export default React.memo(QuestionsCarousel)
